// @flow strict

import type { Store } from "~robin-hood/redux/store";

const STORE_KEY = "MISION_ROBIN_HOOD";
export function loadLocalStore(): Store {
  let store = localStorage.getItem(STORE_KEY);
  if (!store) {
    store = JSON.stringify({});
    localStorage.setItem(STORE_KEY, store);
  }
  return JSON.parse(store);
}

export function updateLocalStore(store: Store): void {
  localStorage.setItem(STORE_KEY, JSON.stringify(store));
}
